import { render } from "./App.vue?vue&type=template&id=8e1a8980"
const script = {}

import "./App.vue?vue&type=style&index=0&id=8e1a8980&lang=css"

import exportComponent from "/Users/vaibhavb/Desktop/Current-Projects/learn/llm/example-llm/scrape-twitter/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__